import Vue from 'vue'
import VueI18n from 'vue-i18n'
import cookie from '@/utils/cookie'

Vue.use(VueI18n)

function getLocale () {
  let language = cookie.getCookie('CometLanguage')
  if (!language) {
    language = navigator.language
  }
  if (language.includes('en')) {
    return 'en-US'
  }
  return 'zh-CN'
}

const languages = [
  { value: 'en-US', label: 'English' },
  { value: 'zh-CN', label: '简体中文' }
]

const messages = {}
for (let lang of languages) {
  let locale = lang.value
  messages[lang.value] = require(`./language/${locale}`).default
}

// load language packages
export default new VueI18n({
  locale: getLocale(),
  messages: messages
})

export { languages }
